import { render, staticRenderFns } from "./SpecificPassport.vue?vue&type=template&id=be029bf8&scoped=true&"
import script from "./SpecificPassport.vue?vue&type=script&lang=js&"
export * from "./SpecificPassport.vue?vue&type=script&lang=js&"
import style0 from "./SpecificPassport.vue?vue&type=style&index=0&id=be029bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be029bf8",
  null
  
)

export default component.exports